export const mode = "development"; //process.env.REACT_APP_APP_MODE;
let domain = "";

switch (mode) {
  case "ip":
    domain = "http://10.10.106.17:8000/";
    break;
  case "local":
    domain = "http://localhost:8000/";
    break;
  case "production":
      // domain = "https://wehear-tinnix-backend-production.up.railway.app/";
    domain = "https://servertinnix.wehear.in/";
    break;
  case "development":
    domain = "https://tinnixdevelopment.wehear.in/"
    break;
  default:
    domain = "http://localhost:8000/";
}

export default {
    root: domain,
    signIn: `${domain}api/auth/login`,
    resetToken: `${domain}api/auth/reset-token`,
    userAndSystemFetchByToken :`${domain}api/user/fetch-by-token`,

    CreatePatient:`${domain}api/patient/`,
    FetchPatient:`${domain}api/patient/`,
    updatePatient:`${domain}api/patient/`,
    FetchPatientById:`${domain}api/patient/by-id`,

    filefirebaseCreateurl:`${domain}api/file/audio`,
    CreateTherapy:`${domain}api/therapy/`,
    FetchAudio:`${domain}api/therapy/fetch-audio`,

    UserCreateApi: `${domain}api/user/`,
    UserFetchByIdApi: `${domain}api/user/fetch-by-id`,
    UserUpdateApi: `${domain}api/user/`,
    UserFetchApi:`${domain}api/user/`,
    UserDelete:`${domain}api/user/`,
    UserSearch:`${domain}api/user/search`,
    UserResetPassword:`${domain}api/user/reset-password`,
    changeUserParrent:`${domain}api/user/add-parent`,


    fetchUsageTime : `${domain}api/usage-time/`,
    fetchDailyUsageTime : `${domain}api/usage-time/daily-weekly`,
    fetchUsageTimeByTherapy: `${domain}api/usage-time/therapy`,
}